import { FC, HTMLAttributes } from 'react';
import { useProductContext } from './useProductContext';
import cn from 'classnames';
import { IconPoints } from '@pro/common/IconPoints';
import { useTrans } from 'base/utils/i18n';

export type IProductPointsProps = HTMLAttributes<HTMLDivElement>;

export const ProductPoints: FC<IProductPointsProps> = props => {
    const {
        product,
        points,
    } = useProductContext();
    const { t } = useTrans();

    const { className } = props;
    const ratio = product.points?.ratio;

    return points === false || !(typeof ratio === 'number' && ratio > 1) ? null : (
        <div className={cn(className, 'g-points')}>
            <IconPoints className={'g-icon-points'}/>
            <span className={'g-text'}>
                {t('web_product_ratio_points', {ratio})}
            </span>
        </div>
    )
};